
import {defineComponent} from "vue";
import {ContentOverviewRestDto, TextWithTitleContentRestDto} from "@/api/pharma-cms-content-block/models";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import PreviewOverviewItem from "@/components/layouts/previews/PreviewOverviewItem.vue";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FormMixin} from "@/components/base/FormMixin";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseOffcanvas from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvas.vue";
import CustomCssPreviewContentBlocksDetail from "@/pages/previews/CustomCssPreviewContentBlocksDetail.vue";
import BaseModalButton from "@/components/UI/Bootstrap/Modal/BaseModalButton.vue";
import InputText from "@/components/UI/InputText.vue";
import BaseModal from "@/components/UI/Bootstrap/Modal/BaseModal.vue";
import {generateUUIDv4} from "@/helpers/functions/string";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {TextWithTitleContentRestDtoModel} from "@/models/api/pharma-cms-content-block/TextWithTitleContentRestDtoModel";
import {AuthContext} from "@/context/AuthContext";

export default defineComponent({
  name: "CustomCssPreviewContentBlocksOverview",
  mixins: [FormMixin],
  components: {
    GenericFormWrapper,
    BaseModal, InputText,
    BaseModalButton,
    CustomCssPreviewContentBlocksDetail,
    BaseOffcanvas, AlertError2, BaseTitle, PreviewOverviewItem},
  data: () => ({
    modalId: generateUUIDv4('modal-content-new-custom-css-preview-') as string,
    contentBlocks: [] as ContentOverviewRestDto[],
    newContentBlock: TextWithTitleContentRestDtoModel.createWithDefaults() as TextWithTitleContentRestDto,
    selectedContentBlockId: undefined as string | undefined,
    contentBlockSequence: 0 as number,
    contentBlockType: 'CUSTOM_CSS_PREVIEW'
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    hasContentBlocks(): boolean {
      return this.contentBlocks.length > 0;
    },
  },
  methods: {
    async submitData(): Promise<void> {
      await this.performGenericSubmit(this.doSubmit, this.afterCreate);
    },
    async doReload(): Promise<void> {
      this.contentBlocks = await NormalContentBlockRestService.getInstance().findContentBlockOverview(this.contentBlockType);
      this.newContentBlock = TextWithTitleContentRestDtoModel.createWithDefaults();
    },
    async deleteContentBlock(contentBlock: ContentOverviewRestDto): Promise<void> {
      await this.deleteItemWithKey(contentBlock.id);
    },
    async doDeleteItemWithKey(itemKey: string): Promise<void> {
      await NormalContentBlockRestService.getInstance().deleteContentBlock(this.contentBlockType, itemKey);
    },
    updateContentBlock(contentBlock: ContentOverviewRestDto): void {
      this.selectedContentBlockId = contentBlock.id;
      this.contentBlockSequence++;
      this.openOffCanvas('customCssPreviewDetailOffCanvas');
    },
    async doSubmit() {
      await NormalContentBlockRestService.getInstance().createNormalContentBlockTextWithTitle(this.newContentBlock, this.contentBlockType);
    },
    async afterCreate(): Promise<void> {
      await this.afterSave();
      this.closeModal(this.modalId);
    },
    hasAuthorization(): boolean {
      return AuthContext.isDpUser();
    }
  }
});
